/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccessTokenExpirationTimeDto } from './AccessTokenExpirationTimeDto';
import type { AccessTokenPermissionAssignmentDto } from './AccessTokenPermissionAssignmentDto';

export type CreateAccessTokenRequest = {
    domains: Array<AccessTokenPermissionAssignmentDto>;
    expirationTime: AccessTokenExpirationTimeDto;
    name: string;
    role: CreateAccessTokenRequest.role;
};

export namespace CreateAccessTokenRequest {

    export enum role {
        ADMIN = 'Admin',
        EDITOR = 'Editor',
        VIEWER = 'Viewer',
        AGENT_SERVICE_ACCOUNT = 'Agent Service Account',
    }


}
